import AuthLogo from './AuthLogo';
export default AuthLogo;
